import request from '@/utils/request'
import axios from 'axios'
import { getToken } from '@/utils/auth'

export function updateState(data) {
  return request({
    url: `/bizTaskDecomposition/updateState`,
    method: 'post',
    data
  })
}
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true,
  timeout: 10000
})

// 导出
export function downloadExcel(url,params,label,date) {
  service({
    method: 'get',
    url: url,
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      filename: 'utf-8',
    },
    params
  }).then(res => {
    const fileName = `${label}.xls`
    const url = window.URL.createObjectURL(res.data)
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    document.body.appendChild(link)
    link.setAttribute('download', fileName)
    link.target = '_blank'
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }).catch(error => {
    console.log(error)
  })
}
